<div class="common-drop-down-arrow drop-down">
  <span class="name">{{ name }}</span>
  @if (required) {
    <span class="required-red">*</span>
  }
  @if (translatePipePath !== undefined) {
    <ng-select
      #selectCause
      [dropdownPosition]="dropdownPosition"
      (blur)="onSaveModel()"
      (focus)="onSaveState()"
      (close)="onClose()"
      [clearable]="false"
      [(ngModel)]="selectedItemId"
      [ngClass]="{ noborder: noBorderAndArrow, custom: !noBorderAndArrow, 'recommended-yellow-background': recommended, 'hide-arrow': noArrowOnDisabled && disabled }"
      [disabled]="!!disabled"
      [multiple]="multiple"
      [closeOnSelect]="closeOnSelect"
      [placeholder]="placeholder"
      [appendTo]="appendTo"
      (change)="onChange()"
      >
      @for (item of items; track item) {
        <ng-option [value]="item.id" [disabled]="item.disabled">
        {{ translatePipePath + item.name | translate }}</ng-option>
      }
      @if (multiSelectedLabel !== undefined) {
        <ng-template ng-multi-label-tmp>
          <div class="multi-selected-label">{{ translatePipePath + multiSelectedLabel | translate: { number: selectedItemId.length } }}</div>
        </ng-template>
      }
      @if (displayMissingLabel(); as item) {
        <ng-template ng-label-tmp let-item="item">
          {{ missingItemLabel }}
        </ng-template>
      }
    </ng-select>
  }

  @if (translatePipePath === undefined) {
    <ng-select
      #selectCause
      (blur)="onSaveModel()"
      (focus)="onSaveState()"
      (close)="onClose()"
      [clearable]="false"
      [dropdownPosition]="dropdownPosition"
      [(ngModel)]="selectedItemId"
      [ngClass]="{ noborder: noBorderAndArrow, custom: !noBorderAndArrow, 'hide-arrow': noArrowOnDisabled && disabled }"
      [disabled]="!!disabled"
      [multiple]="multiple"
      [closeOnSelect]="closeOnSelect"
      [placeholder]="placeholder"
      [items]="items"
      [appendTo]="appendTo"
      bindLabel="name"
      bindValue="id"
      (change)="onChange()"
      [class.required-red-background]="requiredRedBackground && !this.selectedItemId"
      [class.required-red-label]="requiredRedLabel"
      [class.recommended-yellow-background]="recommended"
      >
      <ng-template ng-option-tmp let-item="item">
        {{ item.name }}
      </ng-template>
      @if (!displayMissingLabel(); as item) {
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }}
        </ng-template>
      }
      @if (multiSelectedLabel !== undefined) {
        <ng-template ng-multi-label-tmp>
          <div class="multi-selected-label">{{ multiSelectedLabel }}</div>
        </ng-template>
      }
      @if (displayMissingLabel(); as item) {
        <ng-template ng-label-tmp let-item="item">
          {{ missingItemLabel }}
        </ng-template>
      }
    </ng-select>
  }
</div>
